import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import QuotationList from "./QuotationList"

const Quotation = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
  return (
    <div>
        
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<QuotationList/>}
                menuId={25}
            />
        </DataContext.Provider>
    </div>
  )
}

export default Quotation
